import { useEffect, useState } from "react";
import {
  CompanyType,
  SwitchCompanyDropdown,
} from "./Components/companyDropdown";
import { SwitchProduct } from "./Components/SwitchPlatform";
import { logoDarkImage } from "./Components/images";
import { FlyoutProfile } from "./Components/FlyoutProfile";
import FlyoutSettings from "../FlyoutSettings";
import { useGetPlatformInfo } from "../../queries/idServer";
import { getIdentityDashboardUrl } from "../../api/idServer";
import { useAuthStore } from "../../store";
import NotificationCenter from "./Components/NotificationCenter";

export function TopBarComponent(props: any) {
  const { accessToken } = useAuthStore();

  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [platformData, setPlatformData] = useState<any>(null);
  const [profilePicUrl, setProfilePicUrl] = useState("");

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData);
      setProfilePicUrl(
        userPlatformData?.find(
          (platformData: { platform: string }) =>
            platformData.platform?.toLowerCase() === "esop"
        )?.profilePicUrl || ""
      );
    }
  }, [userPlatformData]);

  const accessiblePlatforms = Array.from(
    new Set(
      platformData
        ?.filter(
          (platform: any) =>
            platform.data.access && platform.platform !== "esop"
        )
        .map((platform: any) => platform.platform)
    )
  );

  return (
    <div className="sticky top-0 right-0 left-0 z-40 bg-white shadow-box">
      <div
        className={`flex h-14 shrink-0 items-center md:gap-x-3 px-4 sm:gap-x-4 sm:px-6 lg:px-6 ${props.className}`}
      >
        <a
          href={getIdentityDashboardUrl()}
          aria-label="Go to Identity dashboard"
          className="cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          {logoDarkImage ? (
            <img className="h-9 mx-auto w-auto" src={logoDarkImage} alt="" />
          ) : (
            <h2 className="text-4xl font-semibold text-secondary">{"hissa"}</h2>
          )}
        </a>
        <form className="relative flex flex-1" action="#" method="GET"></form>

        <SwitchCompanyDropdown />
        <div
          className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
          aria-hidden="true"
        />

        <div className="md:block">
          <FlyoutSettings />
        </div>
        <div className="md:block">
          {accessiblePlatforms.length > 0 && (
            <SwitchProduct data={platformData} />
          )}
        </div>
        <div className="md:block">
          <NotificationCenter />
        </div>
        <div className="md:block">
          <FlyoutProfile profilePicUrl={profilePicUrl} />
        </div>
      </div>
    </div>
  );
}
